import { setIsLoading } from '../../../../../actions/general';
import { callApi } from '../../../../../apiCaller';
import { toastError } from '../../../../../utils';

export const API_ADMIN_USER_TESTS = 'user/test/:testId';
export const API_ADMIN_USER_TEST_DETAILS = 'user/test/admin/:testId/:userId';

export const fetchAdminUserTestsRequest = (testId, setUserTestsBase, setUserTests) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_ADMIN_USER_TESTS.replace(':testId', testId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    const data = response.data;
                    const newUserTests = data.map((ut) => {
                         if (!ut.user || !ut.product) {
                              return false;
                         }

                         const user = ut.user;
                         const product = ut.product;

                         const newUserTest = {
                              ...ut,
                              product: product.name || '',
                              name: user.firstName + ' ' + user.lastName,
                              email: user.email || '',
                              timezone: user.timezone || '',
                         };
                         return newUserTest;
                    });

                    setUserTests(newUserTests);
                    setUserTestsBase(newUserTests);
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const fetchAdminUserTestDetailsRequest = (testId, userId, setUserTestDetails, setQuestions) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_ADMIN_USER_TEST_DETAILS.replace(':testId', testId).replace(':userId', userId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    setUserTestDetails(response.data);
                    setQuestions(response.data?.questions);
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsLoading(false)));
};
